export default __webpack_public_path__ + "static/4-a76e8931450efc5bb059e8b40b7fe1e5.jpg";